// The value limits of a station class, shared by the contract's routes and the console (F-ORG-03,
// spec/04 §3, spec/13 §12).
//
// These are plain values — an enum's members and two ceilings — with no schema and no route machinery
// around them. They live here, apart from `routes/station-classes.ts`, so the console can import them
// without dragging the route graph (and `@hono/zod-openapi`) into the browser bundle: this module and
// the browser-safe `@clavian/contracts/constants` barrel that re-exports it import nothing at all. The
// route file re-imports them from here, so the schemas still read one number.
/** spec/04 §3: one price per player, or one per station however many play on it. */
export const PRICING_MODES = ['per_player', 'per_station'];
/** The most players one station of a class seats by default: a console sofa, a sim rig, a table. */
export const MAX_STATION_CAPACITY = 16;
/** The oldest age limit a class may set. Anything above it is a typo, not a policy. */
export const MAX_CLASS_AGE_LIMIT = 21;
//# sourceMappingURL=station-class.js.map